import apiClient from "./APIClient";

const STORAGE_KEY = "merchantApiCredentials";

export const getStoredCredentials = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const saveCredentials = (creds) => localStorage.setItem(STORAGE_KEY, JSON.stringify(creds));
export const clearCredentials = () => localStorage.removeItem(STORAGE_KEY);

const authHeaders = () => {
  const creds = getStoredCredentials();
  if (!creds?.apiKey || !creds?.secretKey) return {};
  return { "x-api-key": creds.apiKey, "x-secret-key": creds.secretKey };
};

const request = async (method, url, { params, data } = {}) => {
  const res = await apiClient.request({ method, url, params, data, headers: authHeaders() });
  return { status: res.status, data: res.data };
};

export const merchantApi = {
  getWallets:          ()       => request("post", "/merchant-api/wallets"),
  getAllProducts:      (params) => request("post", "/merchant-api/all-products",      { params }),
  getDataProducts:     (params) => request("post", "/merchant-api/data-products",     { params }),
  getGamesProducts:    (params) => request("post", "/merchant-api/games-products",    { params }),
  getSocialProducts:   (params) => request("post", "/merchant-api/social-products",   { params }),
  getOthersProducts:   (params) => request("post", "/merchant-api/others-products",   { params }),
  getProductCategories:(params) => request("get",  "/merchant-api/product-categories",{ params }),
  getProductTypes:     (params) => request("get",  "/merchant-api/product-types",     { params }),
  activateProduct:     (payload)=> request("post", "/merchant-api/products-activation", { data: payload }),
  getRevenueSlabs:     ()       => request("get",  "/merchant-api/charges-product-activation"),
  getOrders:           (params) => request("get",  "/merchant-api/orders",            { params }),
  checkOrderStatus:    (txn)    => request("get",  `/merchant-api/order-status/${txn}`),
};